<template>
  <v-expansion-panel >
    <v-expansion-panel-header class="panel__header" :disable-icon-rotate="true" >
      <template v-if="!editable">
        <div class="panel__header__label">
        ><span class="panel__header__label-content">{{ titleValue }} <slot name="panel__header"></slot></span></div 
      >  
      </template>
      <template v-else>
        <div @mouseover="showEditIcon = true" @mouseleave="showEditIcon = false" class="panel__header__label">
        <div   class="panel__header__label-content">
          <template v-if="!doEdit">
            <span>{{ titleValue }} <slot name="panel__header"></slot></span>
            <div class="panel__header__label--edit-icon pl-1">
            <v-icon v-show="showEditIcon"   @click.stop="toggleEdit" color="grey darken-3">mdi-pencil</v-icon>
            </div>
          </template>
            <template v-else>
              <v-text-field

            v-model="titleValue"
            append-outer-icon="mdi-content-save"
            @click.stop="() => {}"
            @click:append-outer.stop="runEdit"
            style="max-width: 300px; display: inline-flex;"
          />
          <v-icon class="pl-1 pb-6" @click.stop="setDefault" color="grey darken-3">mdi-close</v-icon>
              
            </template>
          </div>
        </div>
      </template>
      
      <template v-slot:actions>
        <slot name="action-before"></slot>
        <v-icon color="#404046">
          {{ selectedPanels.includes(index) ? "mdi-menu-up" : "mdi-menu-down" }}
        </v-icon>
        <slot name="action-after"></slot>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="panel__content">
      <v-row>
        <v-col cols="12">
          <slot></slot>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: "SimpleItemExtensionPanel",
  props: {
    title: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
    },
    selectedPanels: {
      type: Array,
      deault: [],
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      showEditIcon: false,
      doEdit: false,
      titleValue: "",
    }
  },
  watch:{
    title: {
      handler(val){
        this.titleValue = val;
      },
      immediate: true
    }
  },
  methods: {
    runEdit(){
      this.$emit('updateName', this.titleValue);
    },

    setDefault(){
      this.showEditIcon = false;
      this.doEdit = false;
      this.titleValue = this.title;
    },
    toggleEdit(){
      this.showEditIcon = false;
      this.doEdit = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.panel{
  &__content{
    padding: .5em .2em;
  }

  &__header {
    display: flex;
    justify-content: center;
    text-align: center !important;
    background-color: transparent !important;
    position: relative;
    padding: 14px 0;
    

    &__label {
      font-family: Arial, sans-serif!important;
      font-weight: 700!important;
      font-size: 14px!important;
      line-height: 16.1px!important;
      color: #494949!important;
      text-transform: uppercase!important;
      display: flex;
      border-bottom: 1px solid #cdcdcd !important;
      text-align: center;
      
      &--edit-icon{
        width: 30px;
        display: inline-block!important;

      }


      &-content {
        position: absolute;
        left: 32%;  
        display: inline-flex;
        justify-content: center;
        padding: 0 2em;
        min-width: 420px;
        top: 31px;
        background-color: #f0f0f0;
        &::v-deep .v-input--selection-controls{
          margin-top: -7px;
          padding-top: 0;
        }

        &::v-deep .v-text-field{
          margin-top: 0!important;
          padding-top: 0;
        }

        &::v-deep .v-input__slot{
          margin-bottom: 0;
        }
      }
    }
  
}

}



.v-expansion-panel {
  background-color: transparent !important;
  & > .v-expansion-panel-header {
    min-height: 80px !important;
  }
}

.v-expansion-panel-header {
  &:before {
    background-color: transparent;
  }
}
</style>
